import UploadedJobDocumentDetail from './UploadedJobDocumentDetailModel'

export default class UploadedJobDocumentModel {
  public jobId: string
  public documents: UploadedJobDocumentDetail[]
}
